/*******************************************************************************
ADD LEFT/RIGHT ARROWS TO SCROLL TABS
Adds arrows to the sides of the nav bar to indicate more data outside of view.
*******************************************************************************/

import adjustArrows from './adjust';

export default function addScrollTabArrows() {

    $('.scroll-tabs').each((index, nav) => {

        // The scrollable area
        const $scrollableArea = $(nav);

        // If there's a visible scrollbar, we don't need the arrow indicators
        // The check below compares the height of the container (which includes any scrollbars) to the height of the first nav item
        // If they're different, then we know that scrollbars are visible on the page
        //if ($scrollableArea.outerHeight() !== $scrollableArea.find('.scroll-tab:first-child').outerHeight()) { return; }

        // Wrap the scroll tabs with a 'scroll-tabs-outer' div
        if ($scrollableArea.parents('.scroll-tabs-outer').length === 0) {
            $scrollableArea.wrap('<div class="scroll-tabs-outer"></div>');
        }
        const $scrollTabsOuter = $scrollableArea.parents('.scroll-tabs-outer');

        // The HTML for the left and right arrows
        const arrows = '<button class="nav-arrow-left no-ripple"><span>&#9668;</span></button><button class="nav-arrow-right no-ripple"><span>&#9658;</span></button>';

        // Add the arrow elements to the page and set the left arrow position to the edge of the fixed column
        $scrollTabsOuter.append(arrows);

        // Make the initial arrow adjustment
        adjustArrows($scrollableArea);

        // Watch the scroll position and turn the arrows on and off as necessary
        $scrollableArea.on('scroll', () => { adjustArrows($scrollableArea); });

    });

}
